// extracted by mini-css-extract-plugin
module.exports = {"RV-M":"M_RV-M__HfPy4"};